import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchMarketDetails} from '../../actions';
import {splitLines, getParams} from '../../helpers/Utils';


class MarketDetailWheel extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      marketLists: [] ,
      comparisonVisible: props.comparisonVisible
    };  

  }
  
  renderMarketName()
  {
      if(this.state.comparisonVisible){
          return '';
      }
    let name = this.props.marketselected;
    let textFont = "20px futura-pt";
    let lineHeight = 0.15;
    if(name.length >12)
    {
      return splitLines(name, textFont, 150, lineHeight, 90)
    }
    else
    {
      return name;
    }

  }

  updateSVGDimensions() {
    let timeOutValue = 500;
    if (window.navigator.userAgent.indexOf('Trident') !== -1) {
      timeOutValue = 1500;
    }
    setTimeout(() => {
      const marketWheelContainer = document.querySelector('.market-detail-desktop');
      if (!marketWheelContainer) {
        return;
      }

      let elementDetails;
      let excessHeight;
      let marketWheelDetails;
      
      elementDetails = document.getElementById(`Position-5-Quarters`).getBBox();
      excessHeight = elementDetails.height - 110;
      marketWheelDetails = marketWheelContainer.getAttribute('viewBox').split(' ');
      if (excessHeight > 0) {
        let containerDetails = `0 0 650 ${(marketWheelDetails[3] * 1) + excessHeight}`;
        if(this.state.comparisonVisible){
            containerDetails=`-15 0 650 ${(marketWheelDetails[3] * 1) + excessHeight}`;
        }
        marketWheelContainer.setAttribute('viewBox', containerDetails);
      } else {
        if(this.state.comparisonVisible){
            marketWheelContainer.setAttribute('viewBox', `-15 0 650 ${(marketWheelDetails[3])}`);
        }else {
            marketWheelContainer.setAttribute('viewBox', `0 0 650 ${(marketWheelDetails[3])}`);
        }
      }

      elementDetails = document.getElementById(`Position-7-Quarters`)      
      excessHeight = elementDetails.getBBox().height - 121;
      if (excessHeight > 0) {
        elementDetails.setAttribute('transform', `translate(11.000000, 155.000000)`);
      }

      elementDetails = document.getElementById(`Position-3-Quarters`)
      excessHeight = elementDetails.getBBox().height - 121;
      if (excessHeight > 0) {
        elementDetails.setAttribute('transform', `translate(5.000000, 81.000000)`);
      }
      
      elementDetails = document.getElementById(`Position-8-Quarters`)
      excessHeight = elementDetails.getBBox().height - 121;
      if (excessHeight > 0) {
        elementDetails.setAttribute('transform', `translate(11.000000, -10.000000)`);
      }

      elementDetails = document.getElementById(`Position-2-Quarters`)
      excessHeight = elementDetails.getBBox().height - 121;
      if (excessHeight > 0) {
        elementDetails.setAttribute('transform', `translate(5.000000, 91.000000)`);
      }
 

    }, timeOutValue);
  }

componentDidMount()
{
    //Used for Left Panel, always search using the url market data
    const selectedMarket = getParams(window.location, 'market');
    if(selectedMarket !== '')
    {    
        if(selectedMarket.trim() !== this.props.marketselected.trim())
        {
            this.props.fetchMarketDetails('FETCH_MARKET_DETAILS' , selectedMarket);
        }
    }

    // Right Panel on copy paste url
    const compareMarket = getParams(window.location, 'comparemarket');
    if(compareMarket !== '')
    {
        if(compareMarket.trim() !== this.props.comparemarketselected.trim())
        {
         this.props.showRightPanel();
         this.props.hideAddCompareButton();
         this.props.fetchMarketDetails('FETCH_COMPARE_MARKET_DETAILS' , compareMarket);
        }
    }
        
    

    this.updateSVGDimensions();
  //  this.updateMiddleText();
 
  window.addEventListener('popstate', this.handleBackButton, false)
}

handleBackButton = (e) =>
{
    if(this.props.history.action === 'POP')
    {
        e.preventDefault(); 

        const search = window.location.search; 

        const params = new URLSearchParams(search);

        if(params.has('market') === true)
        {
             const selectedMarket = params.get('market');

             this.props.fetchMarketDetails('FETCH_MARKET_DETAILS' , selectedMarket);
        }
 
        if(params.has('comparemarket') === true)
        {
            const compareMarket = params.get('comparemarket');

            this.props.fetchMarketDetails('FETCH_COMPARE_MARKET_DETAILS' , compareMarket); 
            this.props.hideAddCompareButton();
            this.props.showRightPanel();
        }
        else
        {
          
           this.props.onClosePanel();
        } 

    }
}

componentWillUnmount() {
    // you need to unbind the same listener that was binded.
    window.removeEventListener('popstate', this.handleBackButton, false)
}

componentDidUpdate() {
 
 //  this.updateMiddleText();  
    
/*   window.addEventListener('popstate', (event) => {
    console.log("safari", this.props.history.action);
  }); */
/*   
    window.onpopstate  = (e) => {

        if(this.props.history.action == 'POP')
        {
          
            e.preventDefault(); //commented out to test in safari

            const search = window.location.search; 

            const params = new URLSearchParams(search);

            if(params.has('market') === true)
            {
                 const selectedMarket = params.get('market');
 
                 this.props.fetchMarketDetails('FETCH_MARKET_DETAILS' , selectedMarket);
            }
     
            if(params.has('comparemarket') === true)
            {
                const compareMarket = params.get('comparemarket');
 
                this.props.fetchMarketDetails('FETCH_COMPARE_MARKET_DETAILS' , compareMarket); 
                this.props.hideAddCompareButton();
                this.props.showRightPanel();
            }
            else
            {
              
               this.props.onClosePanel();
            } 

            
	} 
 
    } */

}



updateMiddleText(){


    if(this.state.comparisonVisible){
        return;
    }
    let name = this.props.marketselected;
    let timeOutValue = 500;
    if (window.navigator.userAgent.indexOf('Trident') !== -1) {
      timeOutValue = 1500;
    }
    if(name.length <=12)
    {
        setTimeout(() => {
            const historical = document.querySelector('#Historical');
            if (!historical) {
              return;
            }
            historical.setAttribute('y', "46");
      
            const quarter = document.querySelector('#Quarter');
            if (!quarter) {
              return;
            }
            quarter.setAttribute('y', "71");
            
      
          }, timeOutValue);
        return
    }
    setTimeout(() => {
      const historical = document.querySelector('#Historical');
      if (!historical) {
        return;
      }
      historical.setAttribute('y', "55");

      const quarter = document.querySelector('#Quarter');
      if (!quarter) {
        return;
      }
      quarter.setAttribute('y', "75");
      

    }, timeOutValue);
}

getQuartersByPosition(position, x,y) {

    let quarters = [];
    let leftPanelClass="quarters-at-spoke-level";
    if(this.props.comparisonVisible){
        leftPanelClass="left-quarters-at-spoke-level";
    }
    this.props.marketquarters.forEach((element, index) => {
      if ((parseInt(element.position) === position) && element.market.trim() === this.props.marketselected.trim()) {
        if (element.period.length > 0)
        {
            quarters.push(
             <svg style={{ overflow: 'visible' }} key={`svg-${index}`}>
               <rect x={x-4} y={y-14} height="21" width="65" rx="10" className="quarter-at-spoke-background"/>
               <text height="auto">
            <tspan key={`tspan-${index}`} x ={x} y ={y} className={leftPanelClass}>{element.period}</tspan>
            </text>
            </svg> )
            if(position === 2 || position ===1 || position === 6)
            {
                 y = y - 24;
            }
            if (position === 5 || position === 4 || position === 3 )
            {
                y = y + 24;
            }                   
        }
      }
    });

    if(this.props.comparisonVisible){

        this.props.marketCompareQuarters.forEach((element, index) => {
            if ((parseInt(element.position) === position)) {
              if (element.period.length > 0)
              {
                  quarters.push(
                    <svg style={{ overflow: 'visible' }} key={`svg-${element.period}`}>
                    <rect x={x-2} y={y-14} height="21" width="65" rx="10" className="quarter-at-spoke-background-compare"/>
                    <text height="auto">
                  <tspan key={`quarter-${index}`} x ={x} y ={y} className="right-quarters-at-spoke-level">{element.period}</tspan>
                  </text>
                  </svg> 
                  )
                  
                  if(position === 1 || position === 2 ||  position === 6 )
                  {
                    y = y - 24;
                  }
                  if (position === 5 || position === 4 || position === 3 )
                  {
                    y = y + 24;
                  }                   
              }
      
            }
          });
        }
    return quarters;
  }

  getQuartersByPositionDown(position, x,y) {
    let count = 0;
    let countcompare = 0;
    let total = 0;
    let quarters = [];
    let leftPanelClass="quarters-at-spoke-level";

    count = this.props.marketquarters.filter(function (item) { return item.position === position.toString(); });

    if(this.props.comparisonVisible){
        leftPanelClass="left-quarters-at-spoke-level";
        countcompare = this.props.marketCompareQuarters.filter(function (item) { return item.position === position.toString(); });
        total = count.length + countcompare.length;
    }
    else
    {
        total = count.length;
    }

    if (total > 0)
    {
      y = y + (total * 20);
      if (position === 4 && total === 1) //need to remove padding
      {
        y = y - 20;
      }
    }

    this.props.marketquarters.forEach((element, index) => {
      if ((parseInt(element.position) === position) && element.market.trim() === this.props.marketselected.trim()) {
        if (element.period.length > 0)
        {
            quarters.push(
             <svg style={{ overflow: 'visible' }} key={`svg-${index}`}>
               <rect x={x-4} y={y-14} height="21" width="65" rx="10" className="quarter-at-spoke-background"/>
               <text height="auto">
            <tspan key={`tspan-${index}`} x ={x} y ={y} className={leftPanelClass}>{element.period}</tspan>
            </text>
            </svg> )
            if(position ===3 || position === 4 || position === 5)
            {
                 y = y - 24;
            }
        }
      }
    });

    if(this.props.comparisonVisible){

        this.props.marketCompareQuarters.forEach((element, index) => {
            if ((parseInt(element.position) === position)) {
              if (element.period.length > 0)
              {
                  quarters.push(
                    <svg style={{ overflow: 'visible' }} key={`svg-${element.period}`}>
                    <rect x={x-2} y={y-14} height="21" width="65" rx="10" className="quarter-at-spoke-background-compare"/>
                    <text height="auto">
                  <tspan key={`quarter-${index}`} x ={x} y ={y} className="right-quarters-at-spoke-level">{element.period}</tspan>
                  </text>
                  </svg> 
                  )
                  
                  if(position === 3 || position === 4 ||  position === 5)
                  {
                    y = y - 24;
                  }
              }
      
            }
          });
        }
    return quarters;
  }

  hasQuartersByPosition(position)
  {
    return this.getQuartersByPosition(position, 0, 0).length > 0 ? true : false;
  }

  render() {
    
    return (    
      <svg width={this.state.comparisonVisible ? '573px':'620px'} height="910" viewBox="0 0 620 910" fill="none" xmlns="http://www.w3.org/2000/svg">
        
      <g id="Market Rent Details - Desktop">
      <g id="Desktop - Active">
      
                      <g  id="Position-6-Quarters" className="quarters-at-spoke-level" transform="translate(25,190)" fill="#003F2D">
                          {this.getQuartersByPosition(6, 25, 190)} 
                      </g>
                      <g id="Position-3-Quarters" className="quarters-at-spoke-level" transform="translate(255, 280)" fill="#003F2D">
                        {this.getQuartersByPositionDown(3, 255, 280)} 
                      </g>
                      <g id="Position-2-Quarters" className="quarters-at-spoke-level" transform="translate(245, 180)" fill="#003F2D">
                        {this.getQuartersByPosition(2, 245, 180)} 
                      </g>
                      <g id="Position-1-Quarters" className="quarters-at-spoke-level" transform="translate(140, 115)" fill="#003F2D">
                        {this.getQuartersByPosition(1, 140, 115)} 
                      </g>
                      
                      <g id="Position-5-Quarters" className="quarters-at-spoke-level" transform="translate(25, 285)" fill="#003F2D">
                        {this.getQuartersByPositionDown(5, 25, 285)} 
                      </g>
                      <g id="Position-4-Quarters" className="quarters-at-spoke-level" transform="translate(140, 350)" fill="#003F2D">
                        {this.getQuartersByPositionDown(4, 140, 350)} 
                      </g>
      
      <g id="Wheel">
      <path id="Position-1" d="M225.712 311.687C250.961 297.156 279.603 289.506 308.759 289.506C337.915 289.506 366.557 297.156 391.807 311.687L346.131 390.546C334.768 384.007 321.879 380.565 308.759 380.565C295.639 380.565 282.75 384.007 271.388 390.546L225.712 311.687Z" fill="#003F2D" stroke="white" stroke-width="2"/>
      
      <path id="Position-4" d="M391.807 598.448C366.557 612.979 337.915 620.629 308.759 620.629C279.603 620.629 250.961 612.979 225.711 598.448L271.388 519.588C282.75 526.127 295.639 529.57 308.759 529.57C321.879 529.57 334.768 526.127 346.131 519.588L391.807 598.448Z" fill="#003F2D" stroke="white" stroke-width="2"/>
      
      <path id="Position-3" d="M474.855 455.067C474.855 484.129 467.18 512.68 452.602 537.848C438.024 563.016 417.057 583.917 391.807 598.448L346.131 519.588C357.493 513.05 366.928 503.644 373.489 492.319C380.049 480.993 383.502 468.145 383.502 455.067H474.855Z" fill="#003F2D" stroke="white" stroke-width="2"/>
      
      <path id="Position-2" d="M391.807 311.687C417.057 326.218 438.024 347.118 452.602 372.287C467.18 397.455 474.855 426.005 474.855 455.067L383.502 455.067C383.502 441.989 380.049 429.142 373.489 417.816C366.928 406.49 357.493 397.085 346.131 390.546L391.807 311.687Z" fill="#003F2D" stroke="white" stroke-width="2"/>
      
      <path id="Position-6" d="M142.664 455.067C142.664 426.005 150.339 397.455 164.917 372.287C179.494 347.118 200.462 326.218 225.712 311.687L271.388 390.546C260.026 397.085 250.59 406.49 244.03 417.816C237.47 429.142 234.016 441.989 234.016 455.067L142.664 455.067Z" fill="#003F2D" stroke="white" stroke-width="2"/>
      
      <path id="Position-5" d="M225.712 598.448C200.462 583.917 179.494 563.016 164.916 537.848C150.339 512.679 142.664 484.129 142.664 455.067L234.016 455.067C234.016 468.145 237.47 480.993 244.03 492.319C250.59 503.644 260.025 513.05 271.388 519.588L225.712 598.448Z" fill="#003F2D" stroke="white" stroke-width="2"/>
      
      <g id="Spokes">
      <g id="Spoke" className={`${this.hasQuartersByPosition(1) === true ? "show-element" : "hide-element"}`}>
      <circle id="Ellipse 11" cx="309.866" cy="272.679" r="6.67903" fill="#003F2D"/>
      <line id="Line 10" x1="310.265" y1="278.919" x2="310.265" y2="290.895" stroke="#003F2D" stroke-width="4"/>
      </g>
      <g id="Spoke_2" className={`${this.hasQuartersByPosition(4) === true ? "show-element" : "hide-element"}`}>
      <circle id="Ellipse 11_2" cx="308.496" cy="636.921" r="6.67903" transform="rotate(180 308.496 636.921)" fill="#003F2D"/>
      <line id="Line 10_2" x1="308.457" y1="631.358" x2="308.457" y2="619.382" stroke="#003F2D" stroke-width="4"/>
      </g>
      <g id="Spoke_3" className={`${this.hasQuartersByPosition(2) === true ? "show-element" : "hide-element"}`}>
      <circle id="Ellipse 11_3" cx="468.246" cy="365.594" r="6.67903" transform="rotate(60 468.246 365.594)" fill="#003F2D"/>
      <line id="Line 10_3" x1="463.235" y1="369.395" x2="452.864" y2="375.382" stroke="#003F2D" stroke-width="4"/>
      </g>
      <g id="Spoke_4" className={`${this.hasQuartersByPosition(3) === true ? "show-element" : "hide-element"}`}>
      <circle id="Ellipse 11_4" cx="467.358" cy="545.826" r="6.67903" transform="rotate(120 467.358 545.826)" fill="#003F2D"/>
      <line id="Line 10_4" x1="461.842" y1="543.185" x2="451.471" y2="537.197" stroke="#003F2D" stroke-width="4"/>
      </g>
      <g id="Spoke_5" className={`${this.hasQuartersByPosition(5) === true ? "show-element" : "hide-element"}`}>
      <circle id="Ellipse 11_5" cx="150.754" cy="543.936" r="6.67903" transform="rotate(-120 150.754 543.936)" fill="#003F2D"/>
      <line id="Line 10_5" x1="155.659" y1="541.179" x2="166.031" y2="535.191" stroke="#003F2D" stroke-width="4"/>
      </g>
      <g id="Spoke_6" className={`${this.hasQuartersByPosition(6) === true ? "show-element" : "hide-element"}`}>
      <circle id="Ellipse 11_6" cx="151.24" cy="365.207" r="6.67903" transform="rotate(-60 151.24 365.207)" fill="#003F2D"/>
      <line id="Line 10_6" x1="157.036" y1="367.646" x2="167.408" y2="373.634" stroke="#003F2D" stroke-width="4"/>
      </g>
      </g>
      <text id="Rents at Peak" fill="white" xmlSpace="preserve"  font-family="Calibre" font-size="14" font-weight="500" letter-spacing="0em"><tspan x="271" y="343.6">Rents at Peak</tspan></text>
      <text id="Rent Decline Slowing" fill="white" xmlSpace="preserve"  font-family="Calibre" font-size="14" font-weight="500" letter-spacing="0em"><tspan x="389" y="495.6">Rent </tspan><tspan x="389" y="516.6">Decline </tspan><tspan x="389" y="537.6">Slowing</tspan></text>
      <text id="Rent at Trough" fill="white" xmlSpace="preserve"  font-family="Calibre" font-size="14" font-weight="500" letter-spacing="0em"><tspan x="267" y="577.6">Rents at Trough</tspan></text>
      <text id="Rent Growth Accelerating" fill="white" xmlSpace="preserve"  font-family="Calibre" font-size="14" font-weight="500" letter-spacing="0em"><tspan x="180" y="491.6">Rent </tspan><tspan x="180" y="512.6">Growth </tspan><tspan x="180" y="533.6">Accelerating</tspan></text>
      <text id="Rent Growth Slowing" fill="white" xmlSpace="preserve"  font-family="Calibre" font-size="14" font-weight="500" letter-spacing="0em"><tspan x="184" y="378.6">Rent </tspan><tspan x="184" y="399.6">Growth </tspan><tspan x="184" y="420.6">Slowing</tspan></text>
      <text id="Rent Decline Accelerating" fill="white" xmlSpace="preserve"  font-family="Calibre" font-size="14" font-weight="500" letter-spacing="0em"><tspan x="387.267" y="376.352">Rent </tspan><tspan x="387.267" y="397.352">Decline </tspan><tspan x="387.267" y="418.352">Accelerating</tspan></text>
      <g id="Definition - Placeholder">
      <text id="Historical Office Rent Cycle" fill="#435254" xmlSpace="preserve"  font-family="Calibre" font-size="16" letter-spacing="0em"><tspan x="276.898" y="435.4">Historical </tspan><tspan x="271.938" y="457.4">Office Rent </tspan><tspan x="289.336" y="479.4">Cycle</tspan></text>
      </g>
      </g>
      </g>
      </g>
      </svg>
      
    );
  }
}

const mapStateToProps = (state) => {
//const mrketquarters = filterDetailsByMarket(state.marketselected, state.comparisonMarkets.comparisonMarkets)

//console.log(mrketquarters);
    return {
        marketquarters: state.comparisonMarkets.comparisonMarkets[0] ? state.comparisonMarkets.comparisonMarkets[0].marketDetails : [], //mrketquarters.marketDetails,
        marketCompareQuarters: state.comparisonMarkets.comparisonMarkets[1] ? state.comparisonMarkets.comparisonMarkets[1].marketDetails : [],
        marketselected: state.comparisonMarkets.comparisonMarkets[0] ? state.comparisonMarkets.comparisonMarkets[0].market : '',
        comparemarketselected: state.comparisonMarkets.comparisonMarkets[1] ? state.comparisonMarkets.comparisonMarkets[1].market : '',
        //query : query
    };
  };

  const mapDispatchToProps = (dispatch) => {
    return {
      fetchMarketDetails: (actionType, selectedMarket) => {
           dispatch(fetchMarketDetails(actionType, selectedMarket))
      }
    }
  }
export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
        )(MarketDetailWheel)
)
